// extracted by mini-css-extract-plugin
export var blue = "dot-module--blue--3834a";
export var dot = "dot-module--dot--6ae78";
export var dotWrapper = "dot-module--dot-wrapper--05a1d";
export var orange = "dot-module--orange--52299";
export var wrapper = "dot-module--wrapper--0c222";